import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {SecureFuelService} from '../../service/securefuel/secureFuelService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AuthUnitGroupGrid extends BaseComponent {
	
	static get properties() {
		return {
			admin: {type: Boolean}
		};
	}
	
	constructor() {
		super();
						
		this.admin = false;	
		
		var authRulesGrid = this;
		setTimeout(function(){
			authRulesGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var authRulesGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-text-field',
					itemid: 'filterCustomer',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Customer Id',					
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				},
				{
					tag: 'vaadin-checkbox',
					itemid: 'filterReject',
					name: 'reject',
					label: 'All Reject Groups'
				}				
													
			]
		});		
		
		
				
			
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [	
				{						
					path: 'carrierId',
					header: 'Customer Id',
					width: '7em'
				},
				{						
					path: 'groupId',
					header: 'Group Id',
					width: '7em'
				},	
				{						
					path: 'description',
					header: 'Description',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'countryUom',
					header: 'Country Code',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'timeVariance',
					header: 'Time Variance',
					width: '7em'
				},
				{						
					path: 'positionVerify',
					header: 'Position Verify',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'speedTolerance',
					header: 'Speed Tolerance',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateRecCnt',
					header: 'Update Record Count',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'updateMaxMin',
					header: 'Update Max/Min',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'fuelingThreshold',
					header: 'Fueling Threshold',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'mobileGroup',
					header: 'Mobile Group',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'invalidProximityValidationType',
					header: 'Invalid Proximity Validation Type',
					'text-align': 'center',
					width: '7em'
				},
				{						
					path: 'noEventRecordsValidationType',
					header: 'No Event Validation Type',
					'text-align': 'center',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
					grid.selectedItems = item ? [item] : [];					
				}
			}
		});	
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'group-auth-rules',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'group-auth-rules.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		authRulesGrid.append(flexLayout);		
			
		var actionRefresh = function () {


			var customerId = ElementUtil.query(toolbar, 'filterCustomer').value;
			var rejectFlag = ElementUtil.query(toolbar, 'filterReject').checked;

			if (customerId || rejectFlag) {				
				var loadMask = grid.showLoading();
				var processData = function (data) {
					loadMask.remove();

					grid.activeItem = null;
					grid.items = data;
				};

				if (rejectFlag) {
					SecureFuelService.getAuthGroupService().getRejectGroups(customerId).then(function (data) {
						processData(data);
					});
				} else {
					SecureFuelService.getAuthGroupService().getGroupForCustomer(customerId).then(function (data) {
						processData(data);
					});
				}
			} else {
				grid.activeItem = null;
				grid.items = [];
			}
		};
		attachWorkspaceFilterState(authRulesGrid, toolbar, ['filterCustomer','filterReject'], actionRefresh);

	}
	
}
customElements.define('dl-authunit-group-grid', AuthUnitGroupGrid);


